import styled from 'styled-components';

export const ModalContainerMobile = styled.div`
  width: 600px;
  position: fixed;
  background-color: white;
  border: solid 1px gray;
  z-index: 99;
  top: 5vh;
  left: calc(50% - 300px);
  padding:0 40px;
  border-radius: 16px;
  overflow-y: auto;
  max-height: calc(100% - 5vh);

  @media screen and (min-width: 650px) and (max-width: 850px) {
    top: 0;
    left: 0;
    width: 100%;
    height: calc(100% - 75px);
    padding: 0 20px;
    margin-top: 75px;
    border-radius: 16px 16px 0 0;
    position: fixed;
  }
  @media (max-width: 650px) {
    left: 0;
    width: 100%;
    margin-top: 48px;
    height: calc(100% - 48px);
    padding: 0px 15px;
    border-radius: 16px 16px 0 0;
    position: fixed;
  }
`;
export const ContentWrapperText = styled.div`
  padding-bottom: 35px;

`;
export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
`;

export const DetailTextWrapper = styled.div`
  margin: 8px 0;
  line-height: 20px;

  @media (max-width: 650px) {
    margin: 16px 0;
  }
`;
export const ContentWrapper = styled.div`
  height: 100%;
  padding: 10px;
  text-align: center;
  //centrar el contenido del modal
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const DebtDescriptionSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const ButtonsWrapperClose = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 16px;
  width: 100%;
`;

export const ModalImgDivMobile = styled.img`
  height: 297px;

  @media (max-width: 650px) {
    height: 200px;
  }
`;
